import React from 'react';
import SubMenu from './SubMenu';

const ContactLens = props => {
    const { menuData, updateNavValueDtm, section } = props;
    const fetchMenu = menuData.data.map((data, index) => {
        // const subParentKey = data;
        return Object.keys(data).map(key => {
            return (
                <div key={index} className="nav-level-2 cl">
                    <SubMenu submenu={data[key]} updateNavValueDtm={updateNavValueDtm} section={section} />
                </div >
            );
        });
    });

    return (
        <div className="nav-level-acc contact-lens">
            {fetchMenu}
        </div>
    );
};

export default ContactLens;
